import axios from 'axios';
import { REACT_APP_WUCA_API_CLIENT_URL, REACT_APP_WUCA_DXP_API_BEARER_TOKEN } from './config';


export const fetchAllData = async (query: string, variable: any, key: string): Promise<any[]> => {
    let skip = 0;
    const limit = 100;
    const allData: any[] = [];
    let hasMore = true;

    try {
        while (hasMore) {
            const variables = { ...variable, skip };
            //   const variables = { skip };
            // console.log('Fetching data with variables:', variables);
            const response = await axios.post(
                REACT_APP_WUCA_API_CLIENT_URL,
                {
                    query,
                    variables
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${REACT_APP_WUCA_DXP_API_BEARER_TOKEN}`
                    }
                }
            );

            const data: any[] = response.data.data[key].items;

            allData.push(...data);
            skip += limit;
            hasMore = data.length === limit;
        }
    } catch (error: any) {
        console.info('Error fetching users:', error.message || error);
        throw error; // Optional: rethrow for handling in UI
    }

    return allData;
};
